import React, { Component } from "react";
import "./EnterVerifyCode.css";
import Spinner from "./Spinner";
import Api from "./api";
import InputMask from "react-input-mask";

interface Props {
  phoneNumber: string;
  userId: string;
  acceptMarketing: boolean;
  onStepComplete: () => void;
  submitVerifyCode: Api["submitVerifyCode"];
  color: string;
  lightColor: string;
  optinMethod: string;
}

interface State {
  code: string;
  disabled: boolean;
  errorMsg: string;
  processing: boolean;
}

class EnterVerifyCode extends Component<Props, State> {
  state = {
    code: "",
    processing: false,
    disabled: true,
    errorMsg: ""
  };
  handleInputChange = ({
    target: { value: code }
  }: React.ChangeEvent<HTMLInputElement>) => {
    let disabled;

    if (code.match(/[\d]{6}/)) {
      disabled = false;
    } else {
      disabled = true;
    }
    this.setState({ code, disabled: disabled });
  };
  handleCodeSubmit = () => {
    this.setState({ processing: true, errorMsg: "" });
    const { code } = this.state;
    const {
      phoneNumber,
      userId,
      acceptMarketing,
      submitVerifyCode,
      optinMethod,
    } = this.props;
    const c = code.replace(/[^\d]/, "");
    if (c.length === 0) {
      this.setState({
        errorMsg: "Please enter the numeric 6-digit code you were texted.",
        processing: false
      });
    } else if (c.length !== 6) {
      this.setState({
        errorMsg: "The code should contain exactly 6 numbers.",
        processing: false
      });
    } else {
      submitVerifyCode(code, phoneNumber, acceptMarketing, userId, optinMethod)
        .then(async r => {
          const json = await r.json();
          if (r.status === 200) {
            this.props.onStepComplete();
          } else {
            console.log(`Received ${r.status} from the server.`);
            const { detail, type } = json.error;
            detail && console.log(`Error received: ${detail}`);
            let errorMsg = "Uh oh. Something went wrong. Try one more time?";
            if (type === "user" && detail) {
              errorMsg = detail;
            }
            this.setState({
              processing: false,
              errorMsg,
              disabled: false
            });
          }
        })
        .catch(() => {
          this.setState({
            processing: false,
            disabled: false,
            errorMsg: "Uh oh. Something went wrong. Try one more time?"
          });
        });
    }
  };
  render() {
    const { errorMsg, processing, disabled } = this.state;
    const { color, lightColor } = this.props;
    const colors = {
      "--primary-color": color,
      "--secondary-color": lightColor
    } as React.CSSProperties;
    return (
      <div className="EnterVerifyCode" style={colors}>
        <h1>Almost done!</h1>

        <h3 style={{ marginTop: "20px" }}>
          A verification code was sent to your phone number.
          Please input it here to confirm sign up.
        </h3>
        <div className="VerifyArea">
          <div className="Errors">{errorMsg}</div>
          <form className="CodeEntry">
            <InputMask
              maskChar="_"
              mask="999999"
              className="VerifyCode"
              placeholder="Enter the verification code"
              onChange={this.handleInputChange}
            >
              {
                (
                  inputProps: JSX.IntrinsicAttributes &
                    React.ClassAttributes<HTMLInputElement> &
                    React.InputHTMLAttributes<HTMLInputElement>
                ) => <input type="tel" {...inputProps} />
              }
            </InputMask>
            <button
              disabled={processing || disabled}
              className={"Submit" + (processing ? " processing" : "")}
              onClick={this.handleCodeSubmit}
            >
              <Spinner style={{ marginLeft: "30px" }} visible={processing} />
              Submit
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default EnterVerifyCode;
